import React, { useState } from "react";
import { Link } from "react-router-dom";
import { FaFacebookF, FaTwitter, FaInstagram, FaLinkedinIn, FaAndroid } from 'react-icons/fa';
import { FiDownload } from 'react-icons/fi';
import logo from "../assets/Images/logo.png";


function Footer() {
  const [subValue, setSubValue] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubValue("");
    alert("Thank you, you are subscribed to receive our daily newsletter");
  };

  const currYear = new Date().getFullYear();

  const apkUrl = process.env.REACT_APP_APK_URL;
  const apkVersion = process.env.REACT_APP_APK_VERSION;

  return (
    <footer className="modern-footer">
      <div className="footer-main">
        <div className="footer-content">
          <div className="footer-brand">
            <Link to="/" className="footer-logo">
              <img src={logo} alt="CGT Homes Logo" />
            </Link>
            <p className="footer-tagline">
              Your trusted partner for quality home products. Shop with confidence and enjoy amazing deals.
            </p>
            <div className="newsletter-section">
              <h4>Stay Updated</h4>
              <p className="newsletter-text">
                Subscribe to receive exclusive offers and new product updates.
              </p>
              <form onSubmit={handleSubmit} className="newsletter-form">
                <input
                  type="email"
                  placeholder="Enter your email"
                  required
                  value={subValue}
                  onChange={(e) => setSubValue(e.target.value)}
                  className="newsletter-input"
                />
                <button type="submit" className="newsletter-btn">
                  Subscribe
                </button>
              </form>
            </div>
          </div>

          <div className="footer-links-section">
            <div className="footer-column">
              <h4 className="footer-title">Customer Service</h4>
              <ul className="footer-links">
                <li><Link to="/">FAQs</Link></li>
                <li><Link to="/">Track Order</Link></li>
                <li><Link to="/">Return Order</Link></li>
                <li><Link to="/">Warranty Info</Link></li>
                <li><Link to="/contact-us">Contact Us</Link></li>
              </ul>
            </div>

            <div className="footer-column">
              <h4 className="footer-title">Policies</h4>
              <ul className="footer-links">
                <li><Link to="/privacy-policy">Privacy Policy</Link></li>
                <li><Link to="/terms-and-conditions">Terms & Conditions</Link></li>
                <li><Link to="/cancellation-policy">Cancellation Policy</Link></li>
                <li><Link to="/refund-policy">Refund Policy</Link></li>
                <li><Link to="/shipping-policy">Shipping Policy</Link></li>
              </ul>
            </div>

            <div className="footer-column">
              <h4 className="footer-title">Company</h4>
              <ul className="footer-links">
                <li><Link to="/">About Us</Link></li>
                <li><Link to="/">Careers</Link></li>
                <li><Link to="/">Service Centers</Link></li>
                <li><Link to="/">Affiliates</Link></li>
                <li><Link to="/service-pricing">Service Pricing</Link></li>
              </ul>
            </div>
          </div>
        </div>

        {apkUrl && (
          <div className="app-download-banner">
            <div className="app-download-info">
              <FaAndroid className="app-download-icon" />
              <div className="app-download-copy">
                <h4>Get the CGT Homes App</h4>
                <p className="app-download-note">
                  Our Android app is currently in closed testing on the Play
                  Store. Until it goes live, download the APK directly.
                  {apkVersion && (
                    <span className="app-download-meta">
                      {" "}Version {apkVersion} &middot; Android only &middot;
                      Allow installs from unknown sources when prompted.
                    </span>
                  )}
                </p>
              </div>
            </div>
            <a
              href={apkUrl}
              className="app-download-btn"
              download="CGT Homes.apk"
            >
              <FiDownload />
              <span>Download APK</span>
            </a>
          </div>
        )}
      </div>

      <div className="footer-bottom">
        <div className="footer-bottom-content">
          <p className="copyright">
            © {currYear} CGT Homes. All Rights Reserved.
          </p>
          <div className="social-links">
            <a 
              href="https://www.facebook.com/profile.php?id=61571953545303" 
              target="_blank" 
              rel="noopener noreferrer"
              className="social-icon"
              aria-label="Facebook"
            >
              <FaFacebookF />
            </a>
            <a 
              href="https://x.com/CGTHomes" 
              target="_blank" 
              rel="noopener noreferrer"
              className="social-icon"
              aria-label="Twitter"
            >
              <FaTwitter />
            </a>
            <a 
              href="https://www.instagram.com/CGTHomes" 
              target="_blank" 
              rel="noopener noreferrer"
              className="social-icon"
              aria-label="Instagram"
            >
              <FaInstagram />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
